import { render, staticRenderFns } from "./WorkflowQualityControlTable.vue?vue&type=template&id=b736ef00"
import script from "./WorkflowQualityControlTable.vue?vue&type=script&lang=js"
export * from "./WorkflowQualityControlTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports